import { i18n } from '@/i18n'
import { EscapeRegex } from '@/utils'

export default function (value, options = {}) {
  let { type = [], filter = () => true } = options

  value = value instanceof Array ? value : [value]
  type = type instanceof Array ? type : [type]

  let typeInclusions = type.filter(p => !p.startsWith('!'))
  let typeExclusions = type.filter(p => p.startsWith('!')).map(p => p.substring(1))

  let CategoryFilter = item => {
    return (
      !value.length ||
      item.categories.some(category => {
        return value.some(v => new RegExp(`^${EscapeRegex(v)}`, 'i').test(category))
      })
    )
  }

  let TypeFilter = item => {
    if (typeInclusions.length) return typeInclusions.includes(item.type)
    return !typeExclusions.includes(item.type)
  }

  return [
    //Contract
    {
      id: 14442,
      label: i18n.t('tourHowToBuildContract'),
      type: 'manual',
      categories: ['Contract', 'Addons'],
    },
    { type: 'additional-services', id: 'contract', categories: ['Contract'] },
  ].filter(item => CategoryFilter(item) && TypeFilter(item) && filter(item))
}
